import {
  Button,
  Checkbox,
  Col,
  Divider,
  Drawer,
  Progress,
  Row,
  notification,
} from 'antd';
import React, { useEffect, useState } from 'react';
// import logo from '../../assets/images/Logo_Swimbooker 1.svg';
import logo from '../../assets/images/Logo_Swimbooker 1.png';
import memberCard from '../../assets/images/Membership Secure.png';
import tick from '../../assets/images/success-tick.svg';
import pending from '../../assets/images/clock-pending.svg';
import { useHistory } from 'react-router';
import { BackButtonLayout } from '../../../../containers/BackButtonLayout';
import MembershipInfo from './MembershipInfo';
import Step1 from './Step1';
import Step2 from './Step2';
import Step3 from './Step3';
import { useGlobalState } from './GlobalState';
import { useGlobalState as fisheryProfileGlobalState } from '../GlobalState';
import {
  useGetMembershipsPaymentLinkQuery,
  useGetUserMembershipsQuery,
  useRequestMembershipMutation,
} from '../../fisherySlice';
import pdfIcon from '../../assets/images/privacy-policy.svg';
import { useQuery } from '../../../../utils/hooks';
import { useGetUserQuery } from '../../../user_profile/userProfileSlice';

function MembershipDrawer({
  isOpen,
  setIsOpen,
  alreadyMember,
  fisheryId,
  membershipForm,
}) {
  let history = useHistory();
  const isWebview = useQuery().get('isWebview');
  const [membershipContent, setMembershipContent] = useState('info');
  const [currentStep, setCurrentStep] = useState(0);
  const [isSuccessPage, setIsSuccessPage] = useState(false);
  const [isSubmited, setIsSubmited] = useState(false);
  const [userImage, setUserImage] = useGlobalState('userImage');
  const [IDImage, setIDImage] = useGlobalState('IDImage');
  const [termsApproval, setTermsApproval] = useGlobalState('termsApproval1');
  const [termsApproval2, setTermsApproval2] = useGlobalState('termsApproval2');
  const [formState, setFormState] = useGlobalState('formState');
  const [isLoggedIn] = fisheryProfileGlobalState('isLoggedIn');
  const [updatedMemberStatus, setUpdatedMemberStatus] = useState(
    alreadyMember?.length ? alreadyMember[0] : []
  );
  let alreadyMemberValue = alreadyMember?.length ? alreadyMember[0] : [];
  const { data: anglerInfo } = useGetUserQuery();
  const [requestMembership, { isLoading: requestLoading }] =
    useRequestMembershipMutation();
  const { data: userMembershipData, isLoading: userMembershipLoading } =
    useGetUserMembershipsQuery({ data: '' }, { skip: !isLoggedIn });
  const { data: paymentLink } = useGetMembershipsPaymentLinkQuery(
    { plan_id: alreadyMemberValue?.membership_plan_id },
    { skip: !isLoggedIn || !alreadyMember[0]?.membership_plan_id }
  );

  let step2Required =
    membershipForm?.form_element?.car_registration ||
    membershipForm?.form_element?.date_of_birth ||
    membershipForm?.form_element?.date_of_birth ||
    membershipForm?.custom_field_value;

  const steps = [
    {
      content: (
        <Step1
          form={membershipForm}
          loggedIn={isLoggedIn}
          preFillData={anglerInfo}
        />
      ),
      progress: step2Required ? 32 : 49,
    },
    {
      progress: 66,
      content: <Step2 form={membershipForm} />,
    },
    {
      progress: 98,

      content: <Step3 form={membershipForm} />,
    },
  ];

  let step1Validation =
    membershipContent === 'form' &&
    currentStep == 0 &&
    ((membershipForm?.form_element?.phone_number && !formState?.contact) ||
      !formState?.email ||
      !formState?.first_name ||
      !formState?.last_name);
  let step2Validation =
    membershipContent === 'form' &&
    currentStep == 1 &&
    ((membershipForm?.form_element?.car_registration &&
      !formState?.vehicle_registration_no) ||
      (membershipForm?.form_element?.date_of_birth &&
        !formState?.date_of_birth) ||
      (membershipForm?.custom_field_value && !formState?.custom_field) ||
      (membershipForm?.form_element?.address &&
        (!formState?.address_1 ||
          !formState?.postcode ||
          !formState?.city ||
          !formState?.country)));
  const allStockLimitZero = membershipForm?.membership_plans?.every(
    (item) => item.available_stock_limit === 0
  );
  useEffect(() => {
    if (
      (membershipForm?.available_stock_limit == 0 || allStockLimitZero) &&
      membershipForm?.waitlist
    ) {
      setFormState((prevState) => ({
        ...prevState,
        waitlist: true,
      }));
    }
  }, [membershipForm]);
  useEffect(() => {
    if (isSubmited) {
      let member = [];

      if (membershipForm?.type == 'member') {
        member = userMembershipData?.memberships.filter(
          (data) => data.fishery_id == fisheryId && data?.status !== 'Deleted'
        );
      } else {
        member = userMembershipData?.season_tickets.filter(
          (data) => data.fishery_id == fisheryId && data?.status !== 'Deleted'
        );
      }
      if (
        member[0]?.status === 'Active' ||
        member[0]?.status === 'Awaiting Payment' ||
        member[0]?.status === 'Awaiting Confirmation' ||
        member[0]?.status === 'Awaiting Approval'
      ) {
        setUpdatedMemberStatus(member[0]);

        setIsSuccessPage(true);
      }
    }
  }, [fisheryId, userMembershipData]);

  let isWaitlistAndInfo = formState?.waitlist && membershipContent === 'info';
  let sucessTitle = '';
  let sucessDescription = '';

  if (
    alreadyMemberValue?.waitlist ||
    alreadyMemberValue?.status == 'Awaiting Confirmation'
  ) {
    sucessTitle = 'You have been added to the waitlist!';
    sucessDescription = `Thank you for applying to become a ${
      membershipForm?.type == 'member' ? 'member' : 'season ticket holder'
    }  of this venue. You are now on the waitlist and will be contacted via the email provided if a space becomes available. If you have any questions in the meantime, please contact us on 0208 194 9396 or email support@swimbooker.com.`;
  } else if (alreadyMemberValue?.status == 'Awaiting Approval') {
    sucessTitle = 'Your application has been received!';
    sucessDescription = `Your ${
      membershipForm?.type == 'member' ? 'membership' : 'season ticket'
    }  is awaiting approval. Once approved, you will receive an email confirmation stating you have been successful. For questions relating to your application, please contact the fishery directly.`;
  } else if (alreadyMemberValue?.status == 'Awaiting Payment') {
    sucessTitle = 'Awaiting payment for your application!';
    sucessDescription = `Please finalise payment in order to successfully complete your ${
      membershipForm?.type == 'member' ? 'membership' : 'season ticket'
    }  application. If you require assistance, please contact support@swimbooker.com and we'd be happy to help.`;
  } else {
    sucessTitle =
      membershipForm?.type == 'member'
        ? 'You’re already a member!'
        : 'You’re already a season ticket holder';
    sucessDescription = ` It looks like you’re already a ${
      membershipForm?.type == 'member' ? 'member' : 'season ticket holder'
    } at this venue. If you would like to amend your membership please contact the venue directly.`;
  }
  const resetState = () => {
    setIsOpen(false);
    setMembershipContent('info');
    setFormState({
      first_name: '',
      last_name: '',
      email: '',
      contact: '',
      address_1: '',
      address_2: '',
      city: '',
      country: '',
      postcode: '',
      date_of_birth: '',
      vehicle_registration_no: '',
      waitlist: false,
      membership_plan_id: '',
    });
    setCurrentStep(0);
    setIsSubmited(false);
    setIsSuccessPage(false);
    setIDImage('');
    setUserImage('');
    setTermsApproval(false);
    setTermsApproval2(false);
  };

  return (
    <Drawer
      title={null}
      footer={null}
      closeable={false}
      maskCloseable={false}
      className='membership_drawer'
      open={isOpen}
      onClose={() => {
        resetState();
      }}
    >
      <BackButtonLayout
        useCrossIcon
        showBackButton={!isWebview || !isWebview == 'yes'}
        overlapHeader={true}
        onBack={() => {
          resetState();
        }}
      >
        <div
          className={` sb-blue-bg-100
          main_container_padding pd-top-0
          `}
          style={{
            display: 'flex',
            'flex-direction': 'column',
            'justify-content': 'space-between',
            minHeight: '100vh',
          }}
        >
          <React.Fragment>
            <div className={'main_container_padding__content w-full'}>
              <div className='center'>
                <img src={logo} height={100} />
              </div>
              <div
                className=' br30  '
                style={{
                  minHeight: 'calc(100vh - 130px)',
                  display: 'flex',
                  background: '#FAFBFD',
                  flexDirection: 'column',
                }}
              >
                {isSuccessPage ? (
                  <div className='mg-auto pd-20 center'>
                    <img
                      src={
                        updatedMemberStatus?.status == 'Active' &&
                        !updatedMemberStatus?.waitlist
                          ? tick
                          : pending
                      }
                      alt='success-icon'
                      width={250}
                      className='mg-bottom-40'
                    />
                    <div className='gSemiBold fs-30 txt-center mg-bottom-20'>
                      {updatedMemberStatus?.status == 'Active'
                        ? 'Application Successful'
                        : updatedMemberStatus?.waitlist
                          ? 'You have been added to the waitlist!'
                          : 'Submission Pending Approval'}
                    </div>
                    <p className='gMedium fs-16 txt-center mg-bottom-50'>
                      {updatedMemberStatus?.status == 'Active'
                        ? `Thank you for applying to become a ${
                            membershipForm?.type == 'member'
                              ? 'member'
                              : 'season ticket holder'
                          } of this venue. You are application has been successful and you can now make bookings here.`
                        : updatedMemberStatus?.waitlist
                          ? `Thank you for applying to become a ${
                              membershipForm?.type == 'member'
                                ? 'member'
                                : 'season ticket holder'
                            } of this venue. You are now on the waitlist and will be contacted via the email provided if a space becomes available. If you have any questions in the meantime, please contact us on 0208 194 9396 or email support@swimbooker.com`
                          : `Thank you for applying to become a ${
                              membershipForm?.type == 'member'
                                ? 'member'
                                : 'season ticket holder'
                            } of this venue. Your submission has been received and once the venue have made a decision you will be notified by email. If you have any questions or queries you can contact us on: 0208 194 9396 or support@swimbooker.com`}
                    </p>
                    {(!isWebview || !isWebview == 'yes') && (
                      <div className='gap-1r row-center'>
                        <Button
                          style={{
                            'border-radius': '8px',
                            border: '2px solid #1F5B8C',
                            background: 'transparent',
                            height: 'auto',
                          }}
                          onClick={() => {
                            resetState();
                          }}
                          className='gBold fs-20 sb-blue-600 center'
                        >
                          Fishery Profile
                        </Button>
                        {alreadyMemberValue?.status == 'Active' && (
                          <Button
                            style={{
                              'border-radius': '8px',
                              border: '1px solid #AAD2F2',
                              background: 'transparent',
                              height: 'auto',
                            }}
                            onClick={() => {
                              resetState();
                              history.push(`/booking/new/${fisheryId}`);
                            }}
                            className='gBold fs-20 sb-blue-bg-600 white center'
                          >
                            Book Now
                          </Button>
                        )}
                      </div>
                    )}
                  </div>
                ) : alreadyMember?.length > 0 ? (
                  <div className='mg-auto pd-20 center'>
                    <img
                      src={
                        alreadyMemberValue?.status == 'Active'
                          ? memberCard
                          : pending
                      }
                      alt='member-card'
                      width={300}
                    />
                    <div className='gSemiBold fs-30 txt-center mg-bottom-20'>
                      {sucessTitle}
                    </div>
                    <p className='gMedium fs-16 txt-center'>
                      {sucessDescription}
                    </p>
                    {alreadyMemberValue?.status == 'Active' && (
                      <p className='gMedium fs-16 txt-center mg-bottom-40'>
                        Contact details can be found on their swimbooker
                        profile.
                      </p>
                    )}
                    {(!isWebview || !isWebview == 'yes') && (
                      <div className='gap-1r row-center'>
                        <Button
                          style={{
                            'border-radius': '8px',
                            border: '2px solid #1F5B8C',
                            background: 'transparent',
                            height: 'auto',
                          }}
                          onClick={() => {
                            if (
                              paymentLink?.redirect &&
                              alreadyMember[0]?.status === 'Awaiting Payment'
                            ) {
                              window.location.href = paymentLink?.redirect;
                              return;
                            } else {
                              resetState();
                            }
                          }}
                          className='gBold fs-20 sb-blue-600 center'
                        >
                          {paymentLink?.redirect &&
                          alreadyMember[0]?.status === 'Awaiting Payment'
                            ? 'Make Payment'
                            : 'Fishery Profile'}
                        </Button>
                        {alreadyMemberValue?.status == 'Active' && (
                          <Button
                            style={{
                              'border-radius': '8px',
                              border: '1px solid #AAD2F2',
                              background: 'transparent',
                              height: 'auto',
                            }}
                            onClick={() => {
                              resetState();
                              history.push(`/booking/new/${fisheryId}`);
                            }}
                            className='gBold fs-20 sb-blue-bg-600 white center'
                          >
                            Book Now
                          </Button>
                        )}
                      </div>
                    )}
                  </div>
                ) : (
                  <div className='center w-full' style={{ flex: 1 }}>
                    <div className='pd-30'>
                      <div className='fs-30 mg-bottom-10 gSemiBold black txt-center'>
                        {membershipForm?.title}
                      </div>
                      <div className='fs-20 gMedium black txt-center mg-bottom-25'>
                        {membershipForm?.description}
                      </div>
                      <div className='center'>
                        {membershipForm?.rules_pdf && (
                          <a
                            href={membershipForm?.rules_pdf}
                            rel='noopener noreferrer'
                            className='gMedium '
                          >
                            <div
                              className='bg-white gSemiBold fs-22 br10 grey-900 w-fit pd-10 pd-left-20 pd-right-20 row-center'
                              style={{ border: '1px solid #AAD2F2' }}
                            >
                              <img
                                src={pdfIcon}
                                alt='pdf'
                                width={29}
                                className='mg-right-10'
                              />
                              View Venue rules
                            </div>
                          </a>
                        )}
                      </div>
                    </div>
                    <Divider
                      className='mg-0'
                      style={{ background: '#CFCFCF' }}
                    />
                    <div
                      className='pd-30 w-full'
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        flex: 1,
                        justifyContent: 'space-between',
                      }}
                    >
                      <div>
                        {membershipContent === 'info' && (
                          <>
                            <MembershipInfo info={membershipForm} />
                            {formState?.waitlist && (
                              <div className='center'>
                                <div className='gMedium fs-20 txt-center mg-top-30 mg-bottom-50'>
                                  This membership is currently at capacity but
                                  the venue is currently accepting waitlist
                                  applicants. You can apply below.
                                </div>
                                <Button
                                  style={{
                                    border: '1px solid #AAD2F2',
                                    height: 'auto',
                                  }}
                                  disabled={!formState?.membership_plan_id}
                                  onClick={() => setMembershipContent('form')}
                                  className={`gBold br20 pd-20 fs-24 ${
                                    !formState?.membership_plan_id
                                      ? 'grey-bg-400'
                                      : 'sb-blue-bg-600 hover:sb-blue-bg-700'
                                  }  white center`}
                                >
                                  Waitlist Application
                                </Button>
                              </div>
                            )}
                          </>
                        )}
                        {membershipContent === 'form' && (
                          <div className='member-form'>
                            <div className='fs-24 gSemiBold txt-center'>
                              Step{' '}
                              {!step2Required && currentStep > 0
                                ? currentStep
                                : currentStep + 1}{' '}
                              of {step2Required ? 3 : 2}
                            </div>
                            <Progress
                              className='member-form-progress '
                              percent={steps[currentStep].progress}
                              showInfo={false}
                              trailColor={'#E8E8E8'}
                              strokeColor={'#1F5B8C'}
                            />
                            {steps[currentStep].content}
                          </div>
                        )}
                      </div>

                      <div style={{}} className='mg-top-15'>
                        <Row gutter={[0, 10]}>
                          <Col
                            xs={{ span: 24, order: 2 }}
                            sm={{ span: 12, order: 1 }}
                            className='form-buttons'
                          >
                            {membershipContent === 'form' && (
                              <Button
                                className='center cp sb-blue-600  fs-24 w-full h-fit gSemiBold  pd-left-28 pd-right-28'
                                style={{
                                  background: 'transparent',
                                  'border-radius': '8px',
                                  maxWidth: '11rem',
                                  border: '2px solid #1F5B8C',
                                }}
                                onClick={() => {
                                  if (
                                    currentStep == 2 &&
                                    !membershipForm?.form_element
                                      .date_of_birth &&
                                    !membershipForm?.form_element.address &&
                                    !membershipForm?.form_element
                                      .car_registration
                                  ) {
                                    setCurrentStep((prev) => prev - 2);
                                  } else if (currentStep > 0) {
                                    setCurrentStep((prev) => prev - 1);
                                  } else {
                                    setMembershipContent('info');
                                  }
                                }}
                              >
                                Back
                              </Button>
                            )}
                          </Col>
                          <Col
                            xs={{ span: 24, order: 1 }}
                            sm={{ span: 12, order: 2 }}
                            className='form-buttons'
                          >
                            {!isWaitlistAndInfo && (
                              <Button
                                loading={
                                  requestLoading || userMembershipLoading
                                }
                                className={`${
                                  (membershipContent === 'form' &&
                                    currentStep == 2 &&
                                    (!termsApproval ||
                                      (membershipForm?.terms2 &&
                                        !termsApproval2) ||
                                      (membershipForm?.form_element
                                        ?.photo_upload &&
                                        !userImage) ||
                                      (membershipForm?.form_element
                                        ?.id_upload &&
                                        !IDImage))) ||
                                  !formState?.membership_plan_id ||
                                  step1Validation ||
                                  step2Validation
                                    ? 'grey-bg-400'
                                    : 'sb-blue-bg-600 hover:sb-blue-bg-700'
                                }  gSemiBold br10 w-full h-fit fs-24 white txt-center   pd-left-28 pd-right-28 fr`}
                                style={{ maxWidth: '11rem' }}
                                disabled={
                                  (membershipContent === 'form' &&
                                    currentStep == 2 &&
                                    (!termsApproval ||
                                      (membershipForm?.terms2 &&
                                        !termsApproval2) ||
                                      (membershipForm?.form_element
                                        ?.photo_upload &&
                                        !userImage) ||
                                      (membershipForm?.form_element
                                        ?.id_upload &&
                                        !IDImage))) ||
                                  !formState?.membership_plan_id ||
                                  step1Validation ||
                                  step2Validation
                                }
                                onClick={() => {
                                  if (membershipContent === 'info') {
                                    setMembershipContent('form');
                                  } else if (currentStep < 1) {
                                    if (
                                      !membershipForm.form_element
                                        .date_of_birth &&
                                      !membershipForm.form_element.address &&
                                      !membershipForm.form_element
                                        .car_registration
                                    ) {
                                      setCurrentStep((prev) => prev + 2);
                                    } else {
                                      setCurrentStep((prev) => prev + 1);
                                    }
                                  } else if (currentStep < 2) {
                                    setCurrentStep((prev) => prev + 1);
                                  } else {
                                    requestMembership({
                                      ...formState,
                                      user_image: userImage,
                                      id_upload: IDImage,
                                      type: membershipForm?.type,
                                      fishery_id: membershipForm?.fishery_id,
                                    })
                                      .unwrap()
                                      .then((res) => {
                                        if (res?.redirect) {
                                          window.location.href = res.redirect;
                                          return;
                                        }
                                        notification.success({
                                          message: (
                                            <div className='gSemiBold'>
                                              Success!
                                            </div>
                                          ),
                                          style: {
                                            border: '1px #2CB972 solid',
                                          },
                                          placement:
                                            window?.innerWidth <= 500
                                              ? 'bottom'
                                              : 'topRight',
                                          className: 'gRegular br10',
                                          description: 'Request submitted',
                                        });
                                        if (!isLoggedIn) {
                                          setIsOpen(false);
                                          setMembershipContent('info');
                                          setCurrentStep(0);
                                        }

                                        setIsSubmited(true);
                                        setFormState({
                                          first_name: '',
                                          last_name: '',
                                          email: '',
                                          contact: '',
                                          address_1: '',
                                          address_2: '',
                                          city: '',
                                          country: '',
                                          postcode: '',
                                          date_of_birth: '',
                                          vehicle_registration_no: '',
                                        });
                                        setIDImage('');
                                        setUserImage('');
                                        setTermsApproval(false);
                                        setTermsApproval2(false);
                                      });
                                  }
                                }}
                              >
                                {currentStep < 2 ? 'Next' : 'Submit'}
                              </Button>
                            )}
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </React.Fragment>
        </div>
      </BackButtonLayout>
    </Drawer>
  );
}

export default MembershipDrawer;
